module.exports = __webpack_public_path__ + "static/img/s142.8e236b59.png";